export const LOAD_BOOKS = "LOAD_BOOKS";
export const ADD_NEW_BOOK = "ADD_NEW_BOOK";
export const REMOVE_BOOK = "REMOVE_BOOK";
export const OPEN_EDIT_MODE = "OPEN_EDIT_MODE"; 
export const EDIT_BOOK = "EDIT_BOOK"